export default function RulesCard({ rule, index }) {
  return (
    <div className="relative bg-[var(--background)] border-2 border-[var(--hover)] rounded-xl p-3 transition-all duration-300">
      {/* Description */}
      <p className="text-[var(--text)] text-sm md:text-[15px] leading-relaxed">
        {index}. {rule.msg || "No description available."}
      </p>
    </div>
  );
}
